import React from 'react';
import { Card } from 'react-bootstrap';

const ComplementoArrendamientoenfideicomisoResumen = ({ data = [], onEdit, onListChange }) => {

  // const handleEdit = (item) => {
  //   onEdit(item);
  // }

  // const handleDelete = (item) => {
  //   const newData = data.filter((value) => item.id !== value.id);

  //   onListChange(newData);
  // }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Arrendamiento en fideicomiso, Versión { data.Version }</Card.Subtitle>
        <br/>
        <strong className="text-info card-label-info">Pago efectuado: </strong>
        { data.PagProvEfecPorFiduc }
        <br/>

        <strong className="text-info card-label-info">Monto rendimientos: </strong>
        { data.RendimFideicom }
        <br/>

        <strong className="text-info card-label-info">Deducciones: </strong>
        { data.DeduccCorresp }
        <br/>

        <strong className="text-info card-label-info">Monto total retenido: </strong>
        { data.MontTotRet }
        <br/>

        <strong className="text-info card-label-info">Monto del resultado fiscal distribuido por FIBRAS: </strong>
        { data.MontResFiscDistFibras }
        <br/>

        <strong className="text-info card-label-info">Monto otros conceptos distribuidos: </strong>
        { data.MontOtrosConceptDistr }
        <br/>

        <strong className="text-info card-label-info">Descripción otros conceptos distribuidos: </strong>
        { data.DescrMontOtrosConceptDistr }
        <br/>
      </Card.Body>
    </Card>
  )
}

export default ComplementoArrendamientoenfideicomisoResumen
